//
// SORT COMPARATORS
// =====

export const compareAlphabetically = (a, b) :number =>
  `${a}`.localeCompare(`${b}`, 'en-US');

//
// MISCELLANEOUS
// =====

export const trimWala = (str :string, charlist :string) => {
  if (charlist == null) charlist = 's';

  return str.replace(new RegExp('^[' + charlist + ']+'), '');
};

//
// TAGS FOR TEMPLATE LITERALS
// =====
// Suffixes with _ to hint that they're template literal tag functions

/**
 * @example
 *   throw new Error(inline_`Now you can wrap error messages using newlines, and
 *     the new lines and extra whitespace will be condensed to a single space by
 *     the 'inline_' template tag function.`);
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#tagged_templates
 */
export function inline_(strings :TemplateStringsArray, ...values :any[]) :string {
  const result = strings
    .map((str, i) => str + (values[i] ?? ''))
    .join('')
    .replace(/\n(\s\s)*/g, ' ');

  return result;
}
